<template>
    <div class="filter-side">
    <div class="filters-header">
        <h4>Columns</h4>
        <div class="reset-filters"><i class="os-icon-close os-icon"></i><span>Reset Columns</span></div>
    </div>
    <div class="filter-body" >
        <div class="form-group first-child">
            <div class="toggled-buttons">
                <a class="btn btn-toggled"  v-for="column in collapseableColumns" @click="changeColumn(column)" :class="column.toggle">{{column.name}}</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
  props: ['columns'],
  data: function () {
    return {
      collapseableColumns: [
        { name: 'Season', toggle: 'on' },
        { name: 'Description', toggle: 'off' },
        { name: 'Brand', toggle: 'on' },
        { name: 'Category', toggle: 'on' },
        { name: 'Gender', toggle: 'on' }
      ],
      collapsedColumns: ['Description']
    }
  },
  mounted: function () {
    this.$emit('columnInterface', this.collapsedColumns)
  },
  methods: {
    changeColumn (column) {
      if (this.collapsedColumns.indexOf(column.name) === -1) {
        this.collapsedColumns.push(column.name)
      } else {
        this.collapsedColumns.splice(this.collapsedColumns.indexOf(column.name), 1)
      }
      this.collapseableColumns.find((o, i) => { if (o.name == column.name) { o.toggle = (o.toggle == 'on' ? 'off' : 'on'); return true } })
      this.$emit('columnInterface', this.collapsedColumns)
    }
  }
}
</script>

<style scoped>
    .btn-toggled{
        width: 100%
    }
    .toggled-buttons .btn-toggled + .btn-toggled{
        margin-left: 0px;
    }
    .first-child {
        margin-top: 52px;
    }
    .filters-header {
        position: absolute;
        top: 0;
        width: 331px;
        background: #f2f4f8;
        z-index: 999;
    }
    .filter-side{
        overflow: auto;
    }
    .rentals-list-w .filter-side .filter-body {
        padding: 5px 20px 15px 20px
    }
    .rentals-list-w .filter-side .filter-header .no-filter:before{
        background-color:#ddd !important;
    }
    .rentals-list-w .filter-side .filter-header .filter:before{
        background-color:#047bf8 !important;
    }
    .filter-side > :not(.filter-w) + .filter-w{
        margin-top: 54px !important;
    }
    .form-buttons-w{
        padding: 10px;
        float: right;
        position: absolute;
        bottom: 0;
    }

</style>
